"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastBusinessDays = exports.msToTime = void 0;
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
function msToTime(duration) {
    const portions = [];
    const msInHour = 1000 * 60 * 60;
    const hours = Math.trunc(duration / msInHour);
    if (hours > 0) {
        portions.push(hours + "h");
        duration = duration - hours * msInHour;
    }
    const msInMinute = 1000 * 60;
    const minutes = Math.trunc(duration / msInMinute);
    if (minutes > 0) {
        portions.push(minutes + "m");
        duration = duration - minutes * msInMinute;
    }
    const seconds = Math.trunc(duration / 1000);
    if (seconds > 0) {
        portions.push(seconds + "s");
    }
    return portions.join(" ");
}
exports.msToTime = msToTime;
/** Returns `num` business days in the past as moment objects, time will be 8:00 */
function getLastBusinessDays(num) {
    const lastBusinessDay = (0, moment_1.default)().set("milliseconds", 0).set("seconds", 0).set("minutes", 0).set("hours", 8);
    const businessDays = [];
    for (let i = 1; i <= num; i++) {
        const newBusinessDay = lastBusinessDay.subtract(i, "days");
        // remove weekends
        if (newBusinessDay.isoWeekday() === 7)
            newBusinessDay.subtract(2, "days");
        else if (newBusinessDay.isoWeekday() === 6)
            newBusinessDay.subtract(1, "days");
        businessDays.push(newBusinessDay.clone());
    }
    return businessDays;
}
exports.getLastBusinessDays = getLastBusinessDays;
